import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ToastWrapper = styled.div`
    font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
        Arial, sans-serif;
    .Toastify__toast-container {
        width: 384px;
        max-width: calc(100vw - 32px);
        @media (max-width: 480px) {
            top: 1em;
            left: auto;
        }
    }
    .Toastify__toast {
        margin-bottom: 1rem;
        padding: 16px 24px 24px;
        border-radius: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        @media (max-width: 480px) {
            margin-bottom: 1rem;
        }
    }
    .Toastify__progress-bar--default {
        background: #07bc0c;
    }
`;

export const ToastBody = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
        'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);

    span {
        display: flex;
        align-items: center;
        padding-right: 24px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 8px;
        line-height: 24px;
    }
    span svg {
        width: 25px;
        height: 25px;
        margin-right: 15px;
        color: rgb(7, 188, 12);
    }
`;

export const WishListContent = styled.div`
    display: flex;
    align-items: flex-start;
    svg {
        flex-shrink: 0;
    }
    div {
        margin-left: 40px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 29px;
        color: #000000;
    }
`;

export const LinkWrap = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const LinkButton = styled(Link)`
    display: inline-block;
    margin-top: 10px;
    margin-left: auto;
    margin-right: 0;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    border: 1px solid transparent;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    height: 24px;
    padding: 3px 7px 0;
    font-size: 14px;
    text-decoration: none;
    border-radius: 4px;
    color: #fff;
    background-color: rgb(7, 188, 12);
    &:hover {
        text-decoration: none;
        color: #fff;
    }
    &:active {
        text-decoration: none;
        color: #fff;
        background-color: rgba(7, 188, 12, 0.7);
    }
`;
